<!-- 商标需求发布 -->
<template>
  <div class="home">
    <h1>基础信息</h1>
    <div class="content1">
      <div class="form">
        <ul>
          <li class="trademark-category">
            <h2>商标类别</h2>
            <!-- <input type="text" placeholder="请输入" /> -->
            <!-- <div class="sort">
              <el-select v-model="form.trademark_category" placeholder="请选择">
                <el-option
                  v-for="item in dropdownData.trademark_category.data"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
            <div class="category-tags">
              <div
                v-for="item in dropdownData.trademark_category.data"
                :key="item.id"
                class="category-tag"
                :class="{ active: form.trademark_category === item.id }"
                @click="form.trademark_category = item.id"
              >
                {{ item.title }}
              </div>
            </div>
          </li>
          <li>
            <h2>价格预算</h2>
            <div class="sort">
              <el-select v-model="form.budget_id" placeholder="请选择">
                <el-option
                  v-for="item in dropdownData.budget.data"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <h2>标题字数</h2>
            <div class="sort">
              <el-select v-model="form.word_count_id" placeholder="请选择">
                <el-option
                  v-for="item in dropdownData.word_count.data"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <h2>商标结构</h2>
            <div class="sort">
              <el-select
                v-model="form.trademark_structure"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in dropdownData.trademark_structure.data"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </li>
          <li>
            <h2>求购需求说明</h2>
            <input
              type="text"
              placeholder="请输入"
              v-model="form.description"
            />
          </li>
        </ul>
      </div>
      <div class="submit" @click="submitForm">提交</div>
    </div>
  </div>
</template>

<script>
import {
  getParams,
  getPublishTrademarkWantToBuy,
  getMyTrademarkWantToBuyDetail,
  getUpdateTrademarkWantToBuy,
} from "../../api/userApi";
export default {
  data() {
    return {
      isEdit: false, // 是否是编辑模式
      editId: "", // 编辑的ID
      dropdownData: {
        trademark_category: { data: [] },
        budget: { data: [] },
        word_count: { data: [] },
        title_structure: { data: [] },
      },
      form: {
        id: "", // ID编号
        trademark_category: "", // 商标类别
        budget_id: "", // 价格预算
        word_count_id: "", // 标题字数
        trademark_structure: "", // 标题结构
        description: "", // 需求说明
      },
    };
  },
  async created() {
    await this.fetchDropdownData();
    // 检查是否是编辑模式
    if (this.$route.query.id) {
      this.isEdit = true;
      this.editId = this.$route.query.id;
      await this.fetchDetailData();
    }
  },
  methods: {
    // 获取下拉列表数据
    async fetchDropdownData() {
      try {
        const res = await getParams();
        if (res.code === 1) {
          this.dropdownData = res.data;
          console.log(
            this.dropdownData.trademark_structure,
            "获取下拉列表数据"
          );
        }
      } catch (error) {
        console.error("获取下拉数据失败:", error);
        this.$message.error("获取下拉选项失败");
      }
    },

    // 获取详情数据
    async fetchDetailData() {
      try {
        const res = await getMyTrademarkWantToBuyDetail({ id: this.editId });
        console.log(res, "res");

        if (res.code === 1) {
          // 填充表单数据
          const detail = res.data;
          console.log(detail, "detail");

          this.form = {
            id: this.editId,
            trademark_category: String(detail.trademark_category),
            budget_id: detail.budget_id,
            word_count_id: detail.word_count_id,
            trademark_structure: String(detail.trademark_structure),
            description: detail.description,
          };
          console.log(this.form, "this.form");
        } else {
          this.$message.error(res.message || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败，请稍后重试");
      }
    },

    // 提交表单
    async submitForm() {
      // 验证必填字段
      if (!this.form.trademark_category) {
        this.$message.error("请选择商标类别");
        return;
      }
      if (!this.form.budget_id) {
        this.$message.error("请选择价格预算");
        return;
      }
      if (!this.form.word_count_id) {
        this.$message.error("请选择标题字数");
        return;
      }
      if (!this.form.trademark_structure) {
        this.$message.error("请选择标题结构");
        return;
      }
      if (!this.form.description.trim()) {
        this.$message.error("请输入求购需求说明");
        return;
      }

      try {
        // 创建FormData对象
        const formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("trademark_category", this.form.trademark_category);
        formData.append("budget_id", this.form.budget_id);
        formData.append("word_count_id", this.form.word_count_id);
        formData.append("trademark_structure", this.form.trademark_structure);
        formData.append("description", this.form.description);

        let res;
        if (this.isEdit) {
          // 编辑模式，调用更新接口
          res = await getUpdateTrademarkWantToBuy(formData);
        } else {
          // 新增模式，调用创建接口
          res = await getPublishTrademarkWantToBuy(formData);
        }
        if (res.code === 1) {
          this.$message.success(
            res.msg || (this.isEdit ? "修改成功" : "发布成功")
          );
          this.resetForm();
          // 如果是编辑模式，返回列表页
          if (this.isEdit) {
            this.$router.push("/memberCenter/my-publications");
          }
        } else {
          this.$message.error(
            res.msg || (this.isEdit ? "修改失败" : "发布失败")
          );
        }
      } catch (error) {
        console.error("操作失败:", error);
        this.$message.error(
          this.isEdit ? "更新失败，请稍后重试" : "提交失败，请稍后重试"
        );
      }
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: "",
        trademark_category: "",
        budget_id: "",
        word_count_id: "",
        trademark_structure: "",
        description: "",
      };
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
.home {
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #434343;
    line-height: 28px;
    text-align: left;
    margin-left: 20px;
    margin-top: 20px;
  }
  .content1 {
    margin: 0 35px;
    .form {
      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        border-bottom: 1px solid rgba(222, 222, 222, 1);
        padding: 12px 0 32px 0;
        .trademark-category {
          grid-column: span 3; /* 让商标类别占据整行 */
          width: 100%;

          .category-tags {
            display: grid;
            grid-template-columns: repeat(8, 1fr);
            gap: 10px;
            // margin-top: 15px;

            .category-tag {
              // padding: 8px 5px;
              background: #ffffff;
              border: 1px solid #d8d9dc;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
              font-size: 14px;
              color: #434343;
              transition: all 0.3s;
              width: 115px;
              height: 36px;
              box-sizing: border-box;
              line-height: 36px;
              &:hover {
                border-color: #233cac;
                color: #233cac;
              }

              &.active {
                background-color: #233cac;
                color: white;
                border-color: #233cac;
              }
            }
          }
        }
        li {
          // width: 33.3%;
          margin-top: 20px;
          margin-right: 80px;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          // justify-content: flex-start;
          h2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #434343;
            margin-bottom: 15px;
            // text-align: left;
          }
          input {
            width: 259px;
            height: 43px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: none;
            outline: none;
            border: 1px solid #d8d9dc;
            padding-left: 13px;
            box-sizing: border-box;
          }
          input::placeholder {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #b1b1b1;
          }
          .sort {
            ::v-deep .el-input__inner {
              width: 259px;
              height: 43px;
              background: #ffffff;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #d8d9dc;
              padding: 0 13px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
            }
            ::v-deep .el-input__inner::placeholder {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #b1b1b1;
            }
          }
        }
      }
    }
    .submit {
      cursor: pointer;
      width: 83px;
      height: 42px;
      background: #233cac;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 42px;
      border-radius: 5px;
      margin-top: 285px;
      margin-bottom: 56px;
    }
  }
}
</style>
